import { render, staticRenderFns } from "./diseaseGraph.vue?vue&type=template&id=85db331e&scoped=true"
import script from "./diseaseGraph.vue?vue&type=script&lang=js"
export * from "./diseaseGraph.vue?vue&type=script&lang=js"
import style0 from "./diseaseGraph.vue?vue&type=style&index=0&id=85db331e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85db331e",
  null
  
)

export default component.exports